const noop = () => {};

class DelayedAction {
  delay: number;

  onReset: () => void;

  onTime: () => void;

  isRunning: boolean;

  id: number | undefined;

  constructor(delay = 0, { onReset = noop, onTime = noop }) {
    this.delay = delay;
    this.onReset = onReset;

    this.onTime = () => {
      this.isRunning = false;
      onTime();
    };

    this.isRunning = false;
  }

  stop = () => {
    window.clearTimeout(this.id);

    this.isRunning = false;
  };

  reset = () => {
    this.stop();

    this.id = window.setTimeout(this.onTime, this.delay);

    this.isRunning = true;

    this.onReset();
  };
}

export default DelayedAction;
